import 'apps/hiring/styles/components/survey-status-sidebar.scss';
import React from 'react';
import Query from 'apps/hiring/util/query';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';

const STATUSES = [
  /*{category: 'invited', pending:true},*/
  /*{category: 'email_opened', pending: true},*/
  /*{category: 'link_clicked', pending: true},*/
  {category: 'assessment_sign_in', pending: true},
  {category: 'started', pending: true},
  {category: 'real', pending: true},
  {category: 'ideal', pending: true},
  {category: 'assessment_scored', pending: true}
];

const CATEGORY_NAMES = {
  invited: 'Invited',
  //email_opened: 'Email Opened',
  //link_clicked: 'Link Clicked',
  started: 'Started',
  assessment_sign_in: 'Account Created',
  real: 'Part 1 Done',
  ideal: 'Part 2 Done',
  assessment_scored: 'Completed'
};

class SurveyStatusSidebar extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  state = {
    status: [...STATUSES],
    loading: true
  }

  componentDidUpdate(prevProps) {
    if (this.props.user && resolve(prevProps, 'user/id', 0) != resolve(this.props, 'user/id', 0)) {
      this.loadUser(resolve(this.props, 'user/id', null));
    }
  }

  parseStatus = (status, scored) => {
    // look for what index === category
    // set all indexes before to true
    // score==true? all indexes == true

    const out = [...STATUSES];
    const index = (out.findIndex(e=> e.category == status));
    for (let i = 0; i < out.length; i++) {
      out[i].pending = !(scored || (i < index));
    }
    return out;

    /*const out = [];
    for (const s of STATUSES) {
      const index = out.push({...s}) - 1;
      const matchedEvent = status.find(e=>e.category===s.category);
      if (matchedEvent) {
        out[index] = {...out[index], pending:false,...matchedEvent};
        for (let i = 0; i < index; i++) {
          out[i].pending = false;
        }
      }
    }

    if (scored) {
      for (let i = 0; i < out.length; i++) {
        out[i].pending = false;
      }
    }
    return out;*/
  }

  loadUser = async () => {
    this.setState({
      loading: true,
      status: [...STATUSES]
    });

    try {
      const { data } = await Query(`
        {
          assessment (id: ${resolve(this.props, 'user/assessment/id', null)}) {
            scored,
            progress,
            activity_log (limit: 1000) {
              results {
                category,
                data,
                timestamp
              }
            }
          }
        }
      `);

      this.setState({
        status: this.parseStatus(resolve(data, 'assessment/progress', ''), resolve(data, 'assessment/scored', false))
      });
    } catch (e) {
      console.error(e);
    }

    this.setState({
      loading: false
    });
  }

  mapStatus = ({ category, pending, timestamp=null }) => (
    <div className={['hiring-survey-status-status', pending?'pending':null, !timestamp?'derived':null].filter(c=>c).join(' ')}>
      <span className="hiring-survey-status-indicator">
      </span>
      <span className="hiring-survey-status-status-name">
        { resolve(CATEGORY_NAMES, category, 'EVENT') }
        <small>{timestamp}</small>
      </span>
    </div>
  )

  render() {
    const {
      loading,
      status=[]
    } = this.state;

    const {
      user
    } = this.props;
    return (
      <div className="hiring-survey-status">
        <h1>{resolve(user, 'first_name', '')} {resolve(user, 'last_name', '')}</h1>
        <h4>Survey Status</h4>
        <div className={['hiring-survey-status-timeline', loading?'loading':null].filter(c=>c).join(' ')}>
          {
            status.map(this.mapStatus)
          }
          <p><strong>NOTE:</strong>Sometimes survey events are delayed, which can cause them not to register here. If that is the case, the status will update once they reach the step after.</p>
        </div>
      </div>
    );
  }
}

export default SurveyStatusSidebar;
